import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactLink from '@client/components/reactLink/ReactLink';
import DropDownMenu from '@client/containers/dropDownMenu/DropDownMenu';
import indicators from '@client/shared/js/indicators';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './navBarItem.scss';

class NavBarItem extends Component {
  constructor(props) {
    super(props);
  }

  navBarItemText = (entry) => {
    const currentUrl = this.props.location.pathname;
    if (entry.route) {
      return (
        <ReactLink
          to={entry.route}
          className={currentUrl === entry.route ? styles.focused : ''}
        >
          {entry.title}
        </ReactLink>
      );
    }

    return <a>{entry.title}</a>;
  };

  getMenuItemLayout = (entry, subEntries, index) => {
    const currentUrl = this.props.location.pathname;

    if (subEntries && subEntries.length > 0) {
      return (
        <div key={index} className={styles.itemBox}>
          {this.navBarItemText(entry)}
          <img
            className={styles.arrowIcon}
            src={indicators.icon_arrowdown}
            alt="factuals arrow down"
          />
          <div className={styles.dropDownMenu} key={index}>
            <DropDownMenu items={subEntries} />
          </div>
        </div>
      );
    } else {
      return (
        <ReactLink
          to={entry.route}
          className={
            currentUrl === entry.route
              ? styles.focused + ' ' + styles.mainNavBarItem
              : styles.mainNavBarItem
          }
        >
          {entry.title}
        </ReactLink>
      );
    }
  };

  render() {
    const { className, entry, subEntries, index } = this.props;

    return (
      <div
        className={
          className
            ? `${styles.navBarItem} ${themeStyles.headerMenuItem} ${className}`
            : `${styles.navBarItem} ${themeStyles.headerMenuItem} `
        }
      >
        {this.getMenuItemLayout(entry, subEntries, index)}
      </div>
    );
  }
}

NavBarItem.propTypes = {
  className: PropTypes.string,
  currentUrl: PropTypes.string,
  entry: PropTypes.object,
  subEntries: PropTypes.array,
  index: PropTypes.number,
  onMouseEnter: PropTypes.func,
  location: PropTypes.object,
};

export default NavBarItem;
